export const validateUserType=()=>{
    return localStorage.getItem("loginType")==="Company"
}